import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectionsDisplayUpdateOrderRequest } from '../../actions'
import toJS from '../../hoc/toJS'
import MoreElements from '../../components/PageProgram/MoreElements'
import getData from '../../functions/getData'
import { PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_SELECTIONSDISPLAY_ORDER } from '../../constants/state'


const mapStateToProps = state => ({
    displaySelections: getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS),
    displaySelectionsOrder: getData(state, PROGRAM_SELECTIONSDISPLAY_ORDER)
})

const mapDispatchToProps = dispatch => ({
    moveSelection: (dragIndex, hoverIndex) => {
        dispatch(selectionsDisplayUpdateOrderRequest(dragIndex, hoverIndex))
    }
})

export default compose(
    connect(mapStateToProps, null),
    connect(null, mapDispatchToProps),
    toJS()
)(MoreElements)